'use client';

import { ReactNode } from 'react';

interface RecaptchaProviderProps {
  children: ReactNode;
}

// Simple provider wrapper for reCAPTCHA v2
// The actual reCAPTCHA v2 component will be loaded directly in forms
export default function RecaptchaProvider({ children }: RecaptchaProviderProps) {
  return <>{children}</>;
}